import { render, staticRenderFns } from "./BasededatosPacientes.vue?vue&type=template&id=2e310cbd"
import script from "./BasededatosPacientes.vue?vue&type=script&lang=js"
export * from "./BasededatosPacientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports